import { faDownload, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useLingui } from '@lingui/react/macro';
import { Button } from '@repo/videa-components/src/ui/button';

interface ReferralDownloadButtonProps {
  onClick: () => void;
  disabled?: boolean;
  loading?: boolean;
  size?: 'sm' | 'lg';
  variant?: 'outline' | 'default';
  className?: string;
}

export const ReferralDownloadButton = ({
  onClick,
  disabled = false,
  loading = false,
  size = 'sm',
  variant = 'outline',
  className = '',
}: ReferralDownloadButtonProps) => {
  const { t } = useLingui();
  return (
    <Button
      type="button"
      variant={variant}
      size={size}
      onClick={onClick}
      disabled={disabled || loading}
      className={className}
    >
      <FontAwesomeIcon
        icon={loading ? faSpinner : faDownload}
        className={`vai-h-4 vai-w-4 ${
          size === 'lg' ? 'vai-mr-3 vai-h-6 vai-w-6' : 'vai-mr-1'
        } ${loading ? 'vai-animate-spin' : ''}`}
      />
      <div>{loading ? t`Preparing PDF...` : t`Download PDF`}</div>
    </Button>
  );
};
